/** Observation boundary of the verified synthetic export; interaction clocks stay live. */
export const DEMO_OBSERVATION_DATE = "2026-11-03";
export const DEMO_OBSERVATION_MONTH = DEMO_OBSERVATION_DATE.slice(0, 7);
